import { $el } from 'src/scripts/utils/utils'
import { SidebarFilters } from './sidebar-filters'
import { ShopComponent } from '.'

const SHOP_SELECTOR = 'shop-component'

export class SidebarFiltersMobile extends SidebarFilters {
  change(): void {
    const shop: ShopComponent = $el(SHOP_SELECTOR)

    if (shop) {
      this.createQuery()
      shop.updateBySearchParams(this.searchParams)
    }
  }
}
